<template>
    <div style="position: relative;" :class="content.classes" >
        <v-btn
                style="position:relative;"
                class="pl-8 pr-8"
                :class="(content.xLarge && !content.small && !content.large) ? 'v-size--xxl' : ' ' + content.classes"
                @click="toggleOptions"
                :rounded="content.rounded"
                :text="content.text"
                :fab="content.fab"
                :small="content.small"
                :block="content.block"
                :x-large="content.large"
                :outlined="content.outlined"
                :color="content.color"
                :style="'color:'+content.text_color"
                :min-width="content.min_width"
                :min-height="content.min_height"
        >
            <v-icon class="pr-2" v-if="content.icon && content.icon !== ''">
                {{ content.icon }}
            </v-icon>

          <span :style="content['font-family'] ? 'font-family: '+content['font-family']: 'Open Sans, sans-serif;'">
            {{ content.value }}
          </span>

        </v-btn>
        <blocks-models-button-block
                :is_visible="button_dialog"
                :item="content"
                :return_data="toggleOptions"

        ></blocks-models-button-block>

    </div>
</template>

<script>
import BlocksModelsButtonBlock from "@/components/Blocks/Models/ButtonBlock.vue";
    export default {
        props: {
            content: Object,
        },
        components: {
            BlocksModelsButtonBlock
        },
        data() {
            return {
                button_dialog:false,
            }
        },
        methods: {
            toggleOptions()
            {
                this.button_dialog = !this.button_dialog;
            }
        }
    }
</script>
